const Country = {

    // FIELDS
    "country": "Country",
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "search": "Search",
    
    // PAGE HEADER
    "list_title": "Country",
    "filter_title": "Country Filter",
    "add_title": "Add Country",
    "update_title": "Update Country",

    // TABLE HEADER
    "table_name": "Name",
    "table_short_name": "Short Name",
    "table_status": "Status",

    
    // ERROR
    "error_name": "Enter Country Name",
    "error_description": "Enter Description",
    "error_status": "Select Status",

}

export default Country;

